module.exports = __webpack_public_path__ + "assets/img/guide-small.af99d1b8.jpg";